import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is ArcaCentum?",
    a: "ArcaCentum is an all-in-one AI app studio. It helps you find profitable niches, build real working apps from a plain-English description, and discover winning ad creatives you can copy.",
  },
  {
    q: "How do I get started?",
    a: "Just describe your idea in the App Builder. ArcaCentum instantly generates a real, interactive app you can preview live, refine by chatting, and then publish.",
  },
  {
    q: "How does the Niche Finder work?",
    a: "Type any niche and our analyst scores its market potential — verdict, a 1-10 score, revenue estimate and competition level — plus concrete app concepts you can build with one click.",
  },
  {
    q: "Do I need coding experience?",
    a: "No. You describe what you want in plain English and ArcaCentum writes the app for you. You can keep refining it through conversation — no code required.",
  },
  {
    q: "How accurate are the download and revenue estimates?",
    a: "Estimates are AI-generated market signals meant to help you compare and prioritize ideas quickly. Treat them as directional guidance rather than guaranteed figures.",
  },
  {
    q: "What is the App Builder?",
    a: "The App Builder turns your description into a real, functional app with persistent data and a live preview. You can iterate instantly and publish to the App Store and Play Store.",
  },
  {
    q: "What is the Ad Library?",
    a: "A curated collection of high-performing ad creatives and formats from top apps, so you can model what already converts for your own launch.",
  },
  {
    q: "How do credits work?",
    a: "Each plan includes monthly credits used to build and refine apps. Higher tiers include more credits (and first-month bonuses), and you can always buy additional credits.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-28 md:py-36 border-t border-white/10">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#00F0FF] mb-4">/ questions</p>
          <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight">Everything you're wondering.</h2>
        </motion.div>

        <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border border-white/10 rounded-2xl px-6 bg-[#0a0a0a] data-[state=open]:border-[#0055FF]/40 transition-colors duration-300"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="font-display text-lg text-left hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-slate-400 leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
